import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { MemberPlatformMembership } from './MemberPlatformMembership.js';
import { BalanceItemWithPayments } from '../BalanceItem.js';
export class PlatformMembershipMemberDetails extends AutoEncoder {
    firstName = '';
    lastName = '';
    memberNumber;
    get name() {
        if (!this.firstName) {
            return this.lastName;
        }
        if (!this.lastName) {
            return this.firstName;
        }
        return this.firstName + ' ' + this.lastName;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], PlatformMembershipMemberDetails.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], PlatformMembershipMemberDetails.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PlatformMembershipMemberDetails.prototype, "memberNumber", void 0);
export class PlatformMembershipOrganizationDetails extends AutoEncoder {
    name = '';
    uri = '';
}
__decorate([
    field({ decoder: StringDecoder })
], PlatformMembershipOrganizationDetails.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], PlatformMembershipOrganizationDetails.prototype, "uri", void 0);
export class PlatformMembership extends MemberPlatformMembership {
    member;
    balanceItem;
    organization;
}
__decorate([
    field({ decoder: PlatformMembershipMemberDetails })
], PlatformMembership.prototype, "member", void 0);
__decorate([
    field({ decoder: BalanceItemWithPayments, nullable: true, version: 396 })
], PlatformMembership.prototype, "balanceItem", void 0);
__decorate([
    field({ decoder: PlatformMembershipOrganizationDetails })
], PlatformMembership.prototype, "organization", void 0);
//# sourceMappingURL=PlatformMembership.js.map